import dayjs from "dayjs";
import {
    bucketsToCountByDay,
    sumBucketValues,
} from "./dashboardAggregations";

/** Build chart view model for previous calendar month: daily bookings for one location. */
export function buildLastMonthOverviewViewModel({
    colors,
    period,
    yourBookingsByDay,
    yourMonthTotal,
    filterStats,
}) {
    const countByDay = bucketsToCountByDay(yourBookingsByDay, period.start, period.end);
    const dayKeys = Object.keys(countByDay).sort();

    const labels = dayKeys.map((key) => dayjs(key).format("D MMM"));
    const yourCounts = dayKeys.map((key) => countByDay[key]);

    const yourTotal = yourMonthTotal ?? sumBucketValues(yourBookingsByDay);
    const yourAvgPerDay = period.dayCount ? Number((yourTotal / period.dayCount).toFixed(1)) : 0;
    const avgRating = Number(filterStats?.average_rating) || 0;
    const avgLocationRating = Number(filterStats?.average_location_rating) || 0;

    const datasets = [
        {
            label: "Bookings",
            data: yourCounts,
            backgroundColor: colors.seriesPrimaryFill,
            borderColor: colors.seriesPrimaryStroke,
            borderWidth: 1,
            borderRadius: 4,
        },
    ];

    return {
        periodLabel: period.label,
        labels,
        datasets,
        summary: {
            yourTotal,
            yourAvgPerDay,
            avgRating,
            avgLocationRating,
        },
    };
}
